import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
//styled
export default function DeletePostModal({ post, cancelModal, fetchData }) {
  const [deleteComplete, setDeleteComplete] = useState(false);
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/ClubPost/${post.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (deleteResponse.status === 200) {
        fetchData(); // Refresh data after successful deletion
        setDeleteComplete(true); // Indicate successful deletion
      }
    } catch (error) {
      console.error("Error deleting post:", error);
      // Optionally handle the error, e.g., show a message to the user
    } finally {
      setIsLoading(false); // Ensure the loading state is stopped
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (deleteComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete card</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The post was successfully deleted.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete Post</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <div>
              <strong className="red-text">Post</strong> <p>{post.title}</p>
              <p>Are you sure you want to delete this post?</p>
            </div>
            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleClick}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
